import { Button, Stack, Text, Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useNavigate } from 'react-router';
import Metadata from '../components/Metadata';
import { Page } from '../constants/pageTitles';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: 'center' }}>
      <Metadata title={`${Page['notFoundPage']}`} />
      <Stack align="center" gap="xs">
        <Title order={1} fz="120px" fw={700} lh={1}>404</Title>
        <Title order={3} fw={400}>Oops! Page is not available</Title>
        <Text c="dimmed">We are not able to find the page you are looking for</Text>
        <Button mt="xs" leftSection={<IconArrowLeft size={16} />} onClick={() => navigate(-1)}>
          Go Back
        </Button>
      </Stack>
    </div>
  );
};

export default NotFoundPage;
